import { AppBar, IconButton, Button, Toolbar, Typography, Box } from '@mui/material';
import Logo from '../../components/Logo';
import '../../styles/Header.scss';

const Header = ({
  name = 'Personal Property Tax',
  disableSignout = false,
  onLogout,
  logoutText = 'Sign Out',
}) => {
  const linkToAssessorHomePage = 'https://www.utahcounty.gov/Dept/Assess/';

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <AppBar position="static" sx={{ backgroundColor: 'transparent' }}>
          <Toolbar>
            <a href={linkToAssessorHomePage}>
              <IconButton edge="start" aria-label="menu" sx={{ mr: '0.125rem' }}>
                <Logo width="7rem" />
              </IconButton>
            </a>
            <Typography className="app-title" variant="h6" sx={{ flexGrow: 1, color: 'black' }}>
              {name}
            </Typography>
            {disableSignout === false && (
              <Button variant="text" onClick={onLogout}>
                {logoutText}
              </Button>
            )}
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default Header;
